{
  "title": "Accounting",
  "exportCsv": "Export CSV",
  "addEntry": "Add entry",
  "close": "Close",
  "uncategorized": "Uncategorized",
  "periods": {
    "month": "This month",
    "last": "Last month",
    "year": "This year",
    "all": "All time"
  },
  "cards": {
    "income": "Income",
    "expenses": "Expenses",
    "net": "Net",
    "outstanding": "Outstanding",
    "indicative": "indicative · at latest rate"
  },
  "form": {
    "heading": "Manual entry",
    "type": "Type",
    "expense": "Expense",
    "income": "Income",
    "amount": "Amount",
    "rateOptional": "Rate to {primary} (optional)",
    "date": "Date",
    "category": "Category",
    "categoryNone": "(none)",
    "description": "Description",
    "autoFetchHint": "Leave the rate blank to auto-fetch the ECB rate for that date."
  },
  "fx": {
    "needsRateOne": "{n} entry needs an exchange rate",
    "needsRateMany": "{n} entries need an exchange rate",
    "needsRateHelp": "Auto-conversion to {primary} wasn't available. Enter the rate (1 unit → {primary}) to include them in totals.",
    "rateEquals": "1 {currency} =",
    "ratePlaceholder": "rate",
    "apply": "Apply",
    "needsRateShort": "needs rate"
  },
  "breakdown": {
    "incomeByCategory": "Income by category",
    "expensesByCategory": "Expenses by category",
    "noIncome": "No income in this period.",
    "noExpenses": "No expenses in this period.",
    "byCurrency": "By currency (native)",
    "byCurrencyNote": "Totals in each currency's own units, before conversion."
  },
  "teacherPay": {
    "heading": "Teacher pay (this period)",
    "boundedHint": "Pick a bounded period (not “All time”) to value monthly salaries.",
    "teacher": "Teacher",
    "basis": "Basis",
    "perClass": "Per class",
    "monthly": "Monthly",
    "notSet": "not set",
    "sessions": "Sessions",
    "rate": "Rate",
    "pay": "Pay",
    "inPrimary": "In {primary}",
    "needsRate": "needs rate",
    "estimatedTotal": "Estimated total (indicative, at latest rate):",
    "export": "Export teacher pay"
  },
  "ledger": {
    "heading": "Ledger entries",
    "date": "Date",
    "type": "Type",
    "category": "Category",
    "description": "Description",
    "amount": "Amount",
    "inPrimary": "In {primary}",
    "studentPayment": "Student payment",
    "needsRate": "needs rate",
    "emptyHeading": "No entries yet",
    "emptyMessage": "Record a payment or add a manual entry to populate the ledger."
  },
  "toast": {
    "required": "Type, positive amount, currency, and date are required",
    "entryAdded": "Entry added",
    "addFailed": "Failed to add entry",
    "positiveRate": "Enter a positive rate",
    "rateApplied": "Rate applied"
  }
}
